'use client';

import FooterComponent from '@sympla/sympla-components/Footer';
import { analytics, analyticsEvents } from 'lib/analytics';

function Footer() {
  const handleTrackClickOptionAnalytics = ({
    category,
    label
  }: {
    category: string;
    label: string;
  }) => {
    analytics.sendEvent(analyticsEvents.footer_menu_clicked, {
      item_footer_menu_category_title: category,
      item_footer_menu_options: label
    });
  };

  return (
    <div data-testid="footer-container">
      <FooterComponent
        lang="pt"
        onClickOption={handleTrackClickOptionAnalytics}
      />
    </div>
  );
}

export default Footer;
